import { render, staticRenderFns } from "./GetAllFeed.vue?vue&type=template&id=4059904a&"
import script from "./GetAllFeed.vue?vue&type=script&lang=js&"
export * from "./GetAllFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports